module.exports = __webpack_public_path__ + "img/EllipseLila.90432bf5.svg";